import React, { useState } from 'react';

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import Select from 'react-select';

// Data
import { Grid, Input } from "@mui/material";
import SoftAlert from "components/SoftAlert";

import { insertDataJson, updateItem, validateForm } from 'tools/helpers';
import SoftButton from 'components/SoftButton';

function CouponForm({setOpen, getCatalogs = {getCatalogs}, isEdit = false,  event_id}) {
  const currentDate = new Date();
  const expirationDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
  const formattedExpirationDate = expirationDate.toISOString().split('T')[0];

  const emptyData = {
    quantity : '',
    code: '',
    expiration_date: formattedExpirationDate,
    description: '',
    tipo_tarifa: 'Porcentaje',
    porcentage: 100,
  }
  const [formData, setFormData] = useState(emptyData);
  const [statusForm, setStatusForm] = useState({status: null, message: ""});
  const [errorFields, setErrorsFields] = useState([]);

  const setState = (e) => {
    console.log(formData)
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  function selectState(e, item) {
    setFormData({
      ...formData,
      [item.name]: e.value,
    })
  }

  const requiredFields = ['quantity', 'code'];
  const sendForm = async() =>{
    const validationErrors = validateForm(formData, requiredFields);
    setErrorsFields(validationErrors);
    if(validationErrors.length > 0)
    {
      return;
    }

    setStatusForm({status: true, message: "Guardando..."});
    const route = `Coupon`;
    let send = null;

    const newData = {
      ...formData,
      event_id: event_id
    }

    if(isEdit){
      send = await updateItem(`${route}/${formData.id}`, newData);
    }else{
      send = await insertDataJson(route, newData);
    }

    if (send.code === 201) {
      setStatusForm({
        status: true,
        message: "Se ha guardado el cupón satisfactoriamente",
        label: "success",
      });
      setOpen(false);
      setFormData(emptyData);
      getCatalogs();
      return;
    }

    if (send.status === "error") {
      requiredFields.forEach(item=>{
        if (typeof send.errors === 'object'){
          if(item in send.errors){
            setStatusForm({
              status: true,
              message: send.errors[item][0],
              label: "error",
            });
            return;
          }
        }
      })
      return;
    }

    setStatusForm({
      status: true,
      message: "Ha ocurrido algo, intente de nuevo",
      label: "error",
    });
  }
  
  return (
      <SoftBox py={3}>
        <Card style={{ overflow: 'initial'}}>
        <SoftBox sx={8}>
            <Grid p={4}>
              <SoftTypography variant="h5"> Cupón </SoftTypography>
              {
                errorFields.length > 0 ?
                  <SoftAlert color="error"> 
                    <SoftTypography fontSize={12} p={0} color="white"  fontWeight="medium">
                      Campos requeridos (*)
                    </SoftTypography>
                  </SoftAlert>
                : null
              }
              {
                statusForm.status ? (
                  <SoftBox extAlign="center" p={1}>
                    <SoftAlert color={statusForm.label}> 
                      <SoftTypography fontSize={12} p={0} color="white"  fontWeight="medium">
                        {statusForm.message}
                      </SoftTypography>
                    </SoftAlert>
                  </SoftBox>
                ): null
              }
              <Grid py={3} xs={12} container >
                <Grid xs={12} md={4} px={1}>
                  <SoftTypography variant="caption">Número de accesos *:</SoftTypography>
                  <Input 
                    name = "quantity"
                    type = "number"
                    value = {formData.quantity}
                    onChange={setState}
                    className= {errorFields.includes("quantity") ? 'error-field' : null}
                  />
                </Grid>
                <Grid xs={12} md={4} px={1}>
                  <SoftTypography variant="caption">Tipo*: </SoftTypography>
                  <Select
                      className="z-102"
                      name="code"
                      options={[
                        {value:"EXPO", label: "Expositor"},
                        {value:"PATR", label: "Patrocinador"},
                        {value:"CONF", label: "Conferencista"},
                        {value:"INVT", label: "Invitado"},
                        {value:"OPER", label: "Operador"},
                        {value:"ESTU", label: "Estudiante"},
                        {value:"CORT", label: "Cortesía"},
                        {value:"BECA", label: "Beca"},
                        {value:"SOC", label: "Socio"},
                        {value:"STA", label: "Staff"},
                        {value:"OTR", label: "Otro"},
                      ]} 
                      onChange={(e, item)=>selectState(e, item)}
                  />
                </Grid>
                <Grid xs={12} md={4} px={1}>
                  <SoftTypography variant="caption">Vigencia:</SoftTypography>
                  <Input 
                    name = "expiration_date"
                    type = "date"
                    value = {formData.expiration_date}
                    onChange={setState}
                    className= {errorFields.includes("expiration_date") ? 'error-field' : null}
                  />
                </Grid>
                <Grid xs={12} md={6} px={1}>
                  <SoftTypography variant="caption">Asignado a:</SoftTypography>
                  <Input 
                    name = "description"
                    type = "text"
                    value = {formData.description}
                    onChange={setState}
                    className= {errorFields.includes("description") ? 'error-field' : null}
                  />
                </Grid>
                <Grid xs={12} md={3} px={1}>
                  <SoftTypography variant="caption">Tipo de tarifa:</SoftTypography>
                  <select
                      name="tipo_tarifa"
                      value={formData.tipo_tarifa}
                      onChange={setState}
                      className= {errorFields.includes("tipo_tarifa") ? 'error-field select-custom' : 'select-custom'}
                  >
                    <option value="Porcentaje" >% Descuento</option>
                    <option value="Especial">Tarifa Especial</option>
                  </select>
                </Grid>
                <Grid xs={12} md={3} px={1}>
                  <SoftTypography variant="caption">{ formData.tipo_tarifa === "Porcentaje" ? "Porcentaje*" : "Tarifa*" }</SoftTypography>
                  <Input 
                    name = "porcentage"
                    type = "number"
                    value = {formData.porcentage}
                    onChange={setState}
                    className= {errorFields.includes("porcentage") ? 'error-field' : null}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2} p={5} justifyContent='flex-end'>
                <Grid item >
                  <SoftButton
                    md={6}
                    variant="gradient"
                    color= "primary"
                    size="medium"
                    onClick = {()=>sendForm()}
                  >
                    Guardar
                  </SoftButton>
                </Grid>
                <Grid item >
                  <SoftButton
                    md={6}
                    variant="gradient"
                    color= "dark"
                    size="medium"
                    onClick = {()=>setOpen(false)}
                  >
                    Cerrar
                  </SoftButton>
                </Grid>
            </Grid>
          </SoftBox>
        </Card>
      </SoftBox>
  );
}

export default CouponForm;
